import { generateUuid } from '../../../helpers/string';
import { BlockType } from '../../Block/Block';
import { transformToDefaultBlock } from '../../Block/BlockTransformers';
import { transformToImageWithFormats, transformToVideoWithFormats } from '../../Media/MediaTransformers';
import { MediaBannerInterface, MediaBannerResource } from './MediaBanner';

export const transformToMediaBanner = (resource: MediaBannerResource): MediaBannerInterface => {
    const defaultBlock = transformToDefaultBlock(resource);

    const id = defaultBlock.id || generateUuid();

    const image = resource.image.length > 0
        ? transformToImageWithFormats(resource.image)
        : undefined;

    const video = resource.video?.length
        ? transformToVideoWithFormats(resource.video)
        : undefined;

    const anchorTarget = resource.link?.href.startsWith('#')
        ? resource.link.href
        : undefined;

    return {
        ...defaultBlock,
        type: BlockType.mediaBanner,
        title: resource.title,
        titleColor: resource.titleColor || '',
        subtitle: resource.subtitle || '',
        subtitleColor: resource.subtitleColor || '',
        link: resource.link || undefined,
        linkBackgroundColor: resource.linkBackgroundColor,
        media: {
            id,
            video,
            image,
        },
        anchorTarget,
    };
};
